import { render, staticRenderFns } from "./LicenseForms.vue?vue&type=template&id=bf2a1392&"
import script from "./LicenseForms.vue?vue&type=script&lang=js&"
export * from "./LicenseForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports